webpackJsonp([1354000900563],{

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-contact.43896503.jpeg";

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyMXB4IiB2aWV3Qm94PSIwIDAgMjggMjEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjMgKDU3NTQ0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5tYWlsPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGb290ZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MTIuMDAwMDAwLCAtMTI2LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNyI+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MDAuMDAwMDAwLCA0My4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDcuMDAwMDAwLCA4MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI2Ni4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0ibWFpbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTIuNiwwIEwyMy40LDAgQzI0LjgzLDAgMjYsMS4xNyAyNiwyLjYgTDI2LDE4LjIgQzI2LDE5LjYzIDI0LjgzLDIwLjggMjMuNCwyMC44IEwyLjYsMjAuOCBDMS4xNywyMC44IDAsMTkuNjMgMCwxOC4yIEwwLDIuNiBDMCwxLjE3IDEuMTcsMCAyLjYsMCBaIiBpZD0iU2hhcGUiIGZpbGw9IiMxRjgzQzQiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlNoYXBlIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBwb2ludHM9IjI2IDIuNiAxMyAxMS43IDAgMi42Ij48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMjYgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjMgKDU3NTQ0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5tYXAtcGluIGNvcHk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUmVtYXN0ZXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQ29udGFjdC1VcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0NDAuMDAwMDAwLCAtMTE1Ni4wMDAwMDApIiBmaWxsPSIjMUY4M0M0Ij4KICAgICAgICAgICAgPGcgaWQ9Im1hcC1waW4tY29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ0MC4wMDAwMDAsIDExNTYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjYsMTMgQzI2LDIzLjExMTExMTEgMTMsMzEuNzc3Nzc3OCAxMywzMS43Nzc3Nzc4IEMxMywzMS43Nzc3Nzc4IDAsMjMuMTExMTExMSAwLDEzIEMxLjA2OTg1ODkzZS0wNyw1LjgyMDI5ODMzIDUuODIwMjk4MzMsMS45MzcxNTA5NWUtMDcgMTMsMS45MzcxNTA5NmUtMDcgQzIwLjE3OTcwMTcsMS45MzcxNTA5NmUtMDcgMjUuOTk5OTk5OSw1LjgyMDI5ODMzIDI2LDEzIFogTTEzLDE3LjMzMzMzMzMgQzE1LjM5MzIzMzksMTcuMzMzMzMzMyAxNy4zMzMzMzMzLDE1LjM5MzIzMzkgMTcuMzMzMzMzMywxMyBDMTcuMzMzMzMzMywxMC42MDY3NjYxIDE1LjM5MzIzMzksOC42NjY2NjY2NyAxMyw4LjY2NjY2NjY3IEMxMC42MDY3NjYxLDguNjY2NjY2NjcgOC42NjY2NjY2NywxMC42MDY3NjYxIDguNjY2NjY2NjcsMTMgQzguNjY2NjY2NjcsMTUuMzkzMjMzOSAxMC42MDY3NjYxLDE3LjMzMzMzMzMgMTMsMTcuMzMzMzMzMyBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-map.84fbc3a7.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  variant: _propTypes2.default.string.isRequired,
	  icon: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	
	var ContactInfo = function ContactInfo(_ref) {
	  var variant = _ref.variant,
	      icon = _ref.icon,
	      text = _ref.text,
	      url = _ref.url;
	
	  var divClass = 'contact-info';
	  if (!url) {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: variant ? divClass + ' ' + divClass + '--' + variant : divClass
	      },
	      _react2.default.createElement('img', {
	        className: divClass + '__icon ' + divClass + '__icon--' + variant,
	        src: icon,
	        alt: variant
	      }),
	      _react2.default.createElement(
	        'span',
	        { className: variant === 'phone' ? 'text text--number' : 'text' },
	        text
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'a',
	    {
	      className: variant ? divClass + ' ' + divClass + '--' + variant : divClass,
	      href: url,
	      target: '_blank'
	    },
	    _react2.default.createElement('img', {
	      className: divClass + '__icon ' + divClass + '__icon--' + variant,
	      src: icon,
	      alt: variant
	    }),
	    _react2.default.createElement(
	      'span',
	      { className: variant === 'phone' ? 'text text--number' : 'text' },
	      text
	    )
	  );
	};
	
	ContactInfo.propTypes = propTypes;
	
	exports.default = ContactInfo;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.queryContactPage = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(41);
	
	var _sections = __webpack_require__(25);
	
	var _variables = __webpack_require__(79);
	
	var _ContactInfo = __webpack_require__(209);
	
	var _ContactInfo2 = _interopRequireDefault(_ContactInfo);
	
	var _iconBluePhone = __webpack_require__(130);
	
	var _iconBluePhone2 = _interopRequireDefault(_iconBluePhone);
	
	var _iconBlueEnvelope = __webpack_require__(129);
	
	var _iconBlueEnvelope2 = _interopRequireDefault(_iconBlueEnvelope);
	
	var _iconBlueMapPin = __webpack_require__(473);
	
	var _iconBlueMapPin2 = _interopRequireDefault(_iconBlueMapPin);
	
	var _imageMap = __webpack_require__(475);
	
	var _imageMap2 = _interopRequireDefault(_imageMap);
	
	var _heroContact = __webpack_require__(467);
	
	var _heroContact2 = _interopRequireDefault(_heroContact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageContact = function (_Component) {
	  _inherits(PageContact, _Component);
	
	  function PageContact(props) {
	    _classCallCheck(this, PageContact);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      scrollDiv: 'contact-details'
	    };
	    return _this;
	  }
	
	  PageContact.prototype.onButtonClick = function onButtonClick() {
	    scrollToDiv(this.state.scrollDiv);
	  };
	
	  PageContact.prototype.render = function render() {
	    var scrollDiv = this.state.scrollDiv;
	    var data = this.props.data;
	
	    var wp = (0, _helpers.getPageData)(data, 'Contact');
	    return _react2.default.createElement(
	      _sections.PageWrapper,
	      { page: 'contact' },
	      _react2.default.createElement(_sections.Hero, {
	        page: 'contact',
	        data: _extends({}, wp, {
	          hero_background: {
	            localFile: {
	              childImageSharp: {
	                sizes: {
	                  originalImg: _heroContact2.default
	                }
	              }
	            }
	          }
	        }),
	        scrollTo: scrollDiv
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'contact', id: 'contact-details' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'contact__text-col' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'title' },
	              'Get In Touch'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text' },
	              'Please call us to discuss your cleaning project with us. We\u2019ll be sure to get back to you as soon as possible.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contact__info-group' },
	              _react2.default.createElement(_ContactInfo2.default, {
	                variant: 'phone',
	                icon: _iconBluePhone2.default,
	                text: _variables.telNumber + ' or ' + _variables.officeNumber
	                // url={`tel:${telNumber}`}
	              }),
	              _react2.default.createElement(_ContactInfo2.default, {
	                variant: 'email',
	                icon: _iconBlueEnvelope2.default,
	                text: _variables.emailAddress,
	                url: 'mailto:' + _variables.emailAddress
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'contact__image-wrapper' },
	            _react2.default.createElement('img', {
	              className: 'contact__image-pin',
	              src: _iconBlueMapPin2.default,
	              alt: 'Map Pin'
	            }),
	            _react2.default.createElement('img', {
	              className: 'contact__image',
	              src: _imageMap2.default,
	              alt: 'Map of Basingstoke'
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return PageContact;
	}(_react.Component);
	
	exports.default = PageContact;
	var queryContactPage = exports.queryContactPage = '** extracted graphql fragment **';

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var telNumber = exports.telNumber = '+44 (0)7974 872 772';
	var officeNumber = exports.officeNumber = '+44 (0)1256 479 453';
	var emailAddress = exports.emailAddress = 'clear.h2o@live.co.uk';
	var officeAddress = exports.officeAddress = '65 Sinclair Drive, Basingstoke, Hampshire, RG21 6AF';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-page-contact-js-3db8cd71bb5efd05f95f.js